import React from 'react';

const EstimateFormDimensions = ({ dimensions, errors, isReadOnly, onDimensionChange, onAddDimension, onRemoveDimension }) => {
    return (
        <div className="space-y-4">
            {dimensions.map((dimension, index) => (
                <div key={index} className="relative border p-4 rounded-md">
                    <div className="grid grid-cols-5 gap-2">
                        {/* Weight */}
                        <div className="flex flex-col gap-1">
                            <label className="text-sm font-normal">
                                Weight <span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center gap-1">
                                <div className="w-20">
                                    <input
                                        type="number"
                                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${errors[`weight-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                                        value={dimension.weight.value}
                                        onChange={e => onDimensionChange(index, "weight", e.target.value, false)}
                                        readOnly={isReadOnly}
                                        min="0"
                                        step="0.01"
                                        onKeyDown={e => {
                                            if (["e", "E", "+", "-"].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="w-16">
                                    <select
                                        className="w-full h-8 p-1 text-sm border rounded-md outline-none"
                                        value={dimension.weight.unit}
                                        onChange={e => onDimensionChange(index, "weight", e.target.value, true)}
                                        disabled={isReadOnly}
                                    >
                                        <option value="kg">kg</option>
                                        <option value="lbs">lbs</option>
                                    </select>
                                </div>
                            </div>
                            {errors[`weight-${index}`] && (
                                <p className="text-red-500 text-xs mt-1">Weight is required</p>
                            )}
                        </div>
                        {/* Length */}
                        <div className="flex flex-col gap-1">
                            <label className="text-sm font-normal">
                                Length <span className="text-red-500">*</span>
                            </label>
                            <div className="w-20">
                                <input
                                    type="number"
                                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${errors[`length-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                                    value={dimension.length.value}
                                    onChange={e => onDimensionChange(index, "length", e.target.value, false)}
                                    readOnly={isReadOnly}
                                    min="0"
                                    step="0.01"
                                    onKeyDown={e => {
                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                            {errors[`length-${index}`] && (
                                <p className="text-red-500 text-xs mt-1">Length is required</p>
                            )}
                        </div>
                        {/* Width */}
                        <div className="flex flex-col gap-1">
                            <label className="text-sm font-normal">
                                Width <span className="text-red-500">*</span>
                            </label>
                            <div className="w-20">
                                <input
                                    type="number"
                                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${errors[`width-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                                    value={dimension.width.value}
                                    onChange={e => onDimensionChange(index, "width", e.target.value, false)}
                                    readOnly={isReadOnly}
                                    min="0"
                                    step="0.01"
                                    onKeyDown={e => {
                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                            {errors[`width-${index}`] && (
                                <p className="text-red-500 text-xs mt-1">Width is required</p>
                            )}
                        </div>
                        {/* Height */}
                        <div className="flex flex-col gap-1">
                            <label className="text-sm font-normal">
                                Height <span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center gap-1">
                                <div className="w-20">
                                    <input
                                        type="number"
                                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${errors[`height-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                                        value={dimension.height.value}
                                        onChange={e => onDimensionChange(index, "height", e.target.value, false)}
                                        readOnly={isReadOnly}
                                        min="0"
                                        step="0.01"
                                        onKeyDown={e => {
                                            if (["e", "E", "+", "-"].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="w-16">
                                    <select
                                        className="w-full h-8 p-1 text-sm border rounded-md outline-none"
                                        value={dimension.height.unit}
                                        onChange={e => onDimensionChange(index, "height", e.target.value, true)}
                                        disabled={isReadOnly}
                                    >
                                        <option value="cm">cm</option>
                                        <option value="in">in</option>
                                    </select>
                                </div>
                            </div>
                            {errors[`height-${index}`] && (
                                <p className="text-red-500 text-xs mt-1">Height is required</p>
                            )}
                        </div>
                        {/* Quantity */}
                        <div className="flex flex-col gap-1">
                            <label className="text-sm font-normal">
                                Quantity <span className="text-red-500">*</span>
                            </label>
                            <div className="w-20">
                                <input
                                    type="number"
                                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${errors[`quantity-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                                    value={dimension.quantity.value}
                                    onChange={e => onDimensionChange(index, "quantity", e.target.value, false)}
                                    readOnly={isReadOnly}
                                    min="1"
                                    step="1"
                                    onKeyDown={e => {
                                        if (["e", "E", "+", "-"].includes(e.key) || e.key === ".") {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                            {errors[`quantity-${index}`] && (
                                <p className="text-red-500 text-xs mt-1">Quantity is required</p>
                            )}
                        </div>
                    </div>
                    <div className="absolute right-2 top-2 flex space-x-2">
                        {index === dimensions.length - 1 && (
                            <button onClick={onAddDimension} className="px-2 py-1 text-sm bg-green-500 text-white rounded hover:bg-green-600" disabled={isReadOnly}>+</button>
                        )}
                        {dimensions.length > 1 && (
                            <button onClick={() => onRemoveDimension(index)} className="px-2 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600" disabled={isReadOnly}>-</button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EstimateFormDimensions;